import { render, staticRenderFns } from "./ContributionPlanner.vue?vue&type=template&id=36fcd776&scoped=true"
import script from "./ContributionPlanner.vue?vue&type=script&lang=ts"
export * from "./ContributionPlanner.vue?vue&type=script&lang=ts"
import style0 from "./ContributionPlanner.vue?vue&type=style&index=0&id=36fcd776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fcd776",
  null
  
)

export default component.exports